import { useState } from "react";
import { ToastContainer, toast } from 'react-toastify';

import { useEffect } from "react";
import loading from "../../assets/images/loading.gif"
import status from "../../assets/images/total-icon.png"
import number from "../../assets/images/number-icon.png"
import date from "../../assets/images/date-icon.png"
import person from "../../assets/images/user-icon.png"
import { POLineItems, PurchaseOrderInfo } from "../../interfaces/purchaseorder.types";
import { useSelector } from "react-redux";
import { makeDeleteRequest, makeGetRequest, makePatchRequest } from "../../request";
import { customStyles, formatCurrency, formatDateTime, getCurrencySymbol, getPOItemSupplyStatusIndex, getPurchaseOrderItemStatus, handleCopy, POItemSupplyStatus } from "../../helpers";
import Modal from "react-modal"
import { useParams, useNavigate, useLocation } from "react-router-dom";
import Pagination from "../../components/Pagination";
import Layout from "../Layout";
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';

const PurchaseOrder =  () => {
    const navigate = useNavigate()
    const param = useParams()
    const location = useLocation()
    const user:any = useSelector((state: any) => state.tepngUser.value);
    const [purchaseOrder, setRecords] = useState<PurchaseOrderInfo>()
    const [poLineItems, setPoLineItems] = useState<POLineItems[]>()
    const statusBeforeNavigation = location.state as { originName: string };

    // For Purchase Order Items
    const [currentPage1, setCurrentPage1] = useState(1);
    const [itemsPerPage1, setItemsPerPage1] = useState(25);
    const [totalItems1, setTotalItems1] = useState(0);
    const totalPages1 = Math.ceil(totalItems1 / itemsPerPage1);

    const [startIndex, setStartIndex] = useState(0);
    const getPageNumbers = () => {
        return Array.from({ length: totalPages1 }, (_, i) => i + 1);
    };

    const handleNext = () => {
        if (currentPage1 < totalPages1) {
            setCurrentPage1(currentPage1 + 1);
            if (currentPage1 >= startIndex + 4) {
                setStartIndex(startIndex + 4);
            }
        }
    };

    const handlePrevious = () => {
        if (currentPage1 > 1) {
            setCurrentPage1(currentPage1 - 1);
            if (currentPage1 - 1 <= startIndex) {
                setStartIndex(startIndex - 4);
            }
        }
    };

    const [isLoading, setIsLoading] = useState(false)
    const [mainTab, setMainTab] = useState(statusBeforeNavigation?.originName ? statusBeforeNavigation?.originName : "items")
    const [purchaseOrderNumber, setPurchaseOrderNumber] = useState("")
    const [purchaseOrderId, setPurchaseOrderId] = useState("")
    const getPurchaseOrder = () => {
        setIsLoading(true)
        var request: Record<string, any> = {
            what: "getPurchaseOrder",
            id: purchaseOrderNumber,
            params: {
                UserId: user?.id
            }
        };
        
        makeGetRequest(request)
            .then((response: any) => {
                setIsLoading(false)
                const res = response.data.data
                setRecords(res)
                getPurchaseOrderItems(res.id)
                setPurchaseOrderId(res.id)
                // getMRDocuments(res.id)                
            })
            .catch((error:any) => {
                toast.error(error.msg)
                setIsLoading(false)
            });
    }
    const [purchaseOrderCorrespondingDocuments, setPurchaseOrderCorrespondingDocuments] = useState({
        materialReadinessDocuments: [] as any,
        proofOfCollections: [],
        shippingDocuments: [] as any
    })
    const getPurchaseOrderTrackingInformation = () => {
        setIsLoading(true)
        var request: Record<string, any> = {
            what: "getPurchaseOrderTrackingInformation",
            id: purchaseOrderNumber,
            // params: {
            //     UserId: user?.id
            // }
        };
        
        makeGetRequest(request)
            .then((response: any) => {
                setIsLoading(false)
                const res = response.data.data
                setPurchaseOrderCorrespondingDocuments(res)   
            })
            .catch((error:any) => {
                toast.error(error.msg)
                setIsLoading(false)
            });
    }

    const [searchItem, setSearchItem] = useState("")
    const [itemStatus, setItemStatus] = useState("")
    const [filterMaterialNumber, setFilterMaterialNumber] = useState("")
    const getPurchaseOrderItems = (id: string) => {
        setIsLoading(true)
        var request: Record<string, any> = {
            what: "getPurchaseOrderItems",
            id: purchaseOrderNumber,
            params: {
                Page: currentPage1,
                PageSize: itemsPerPage1,  
                PurchaseOrderId: id           
            }
        };
        if(searchItem) request.params.SearchString = searchItem
        if(filterMaterialNumber) request.params.MaterialNumber = filterMaterialNumber
        if(itemStatus) request.params.Status = itemStatus
        
        makeGetRequest(request)
            .then((response: any) => {
                setIsLoading(false)
                const res = response.data
                setPoLineItems(res.data)
                setTotalItems1(res.totalCount)
            })
            .catch((error:any) => {
                toast.error(error.msg)
                setIsLoading(false)
            });
    }

    useEffect(() => {
        if(purchaseOrderId) getPurchaseOrderItems(purchaseOrderId) // eslint-disable-next-line
    }, [searchItem, filterMaterialNumber, itemStatus, itemsPerPage1, currentPage1])

    const handleItemSearch = () => {
        const status = (document.getElementById("itemstatus") as HTMLInputElement)?.value
        const materialNumber = (document.getElementById("materialnumber") as HTMLInputElement)?.value
        const search = (document.getElementById("searchitem") as HTMLInputElement)?.value
        
        if(search) setSearchItem(search)
        if(status !== null) setItemStatus(status)
        if(materialNumber) setFilterMaterialNumber(materialNumber)
    }

    const clearFilters = () => {
        if(searchItem) setSearchItem("")
        if(itemStatus) setItemStatus("")
        if(filterMaterialNumber) setFilterMaterialNumber("");
        (document.getElementById("searchitem") as HTMLInputElement).value = "";
    } 

    const [selectedRow, setSelectedRow] = useState("")
    const [toggleExpand, setToggleExpand] = useState(false)

    useEffect(() => {
        if(purchaseOrderNumber) {
            getPurchaseOrder()
            getPurchaseOrderTrackingInformation()
            navigate("/candp/purchaseorders/"+purchaseOrderNumber)
        } // eslint-disable-next-line
    }, [purchaseOrderNumber])    

    useEffect(() => {
        if(param.id) setPurchaseOrderNumber(param.id); // eslint-disable-next-line
    }, [])

    useEffect(() => {
        if(param.id) {
            const element = (document.getElementById("purchaseOrderNumber") as HTMLInputElement)
            if(element) (document.getElementById("purchaseOrderNumber") as HTMLInputElement).value = param.id
        } // eslint-disable-next-line
    }, [mainTab, document.getElementById("purchaseOrderNumber")])

    const getCAndPMAterialReadinessDocumentStatus = (status: string) => {
        switch(status){
            case "NEW_MATERIAL_READINESS_DOCUMENT": return {
                status: "Open",
                color: "#E38600"
            };
            case "PENDING": return {
                status: "Rejected",
                color: "red"
            };
            default: return {
                status: "Approved",
                color: "green"
            };
        }
    }

    const [arrayOfPOLineItemsForDeletion, setArrayOfPOLineItemsForDeletion] = useState<string[]>([]);
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [materialConfirmationModal, setMaterialConfirmationModal] = useState(false)
    const [selectedItemForDeletion, setSelectedItemForDeletion] = useState({
        purchaseOrderItemRequestId: "",
        purchaseOrderItemNumber: "",
        materialNumber: "",
        quantity: "",
        purchaseOrderItemSupplyId: ""
    })
    const [isConfirmDeleteItemSupply, setIsConfirmDeleteItemSupply] = useState(false)
    const handleCheck = (e:React.ChangeEvent<HTMLInputElement>) => {
        const { value, checked } = e.target
        const selectedItem = poLineItems?.find((item) => item.id === value)
        if (checked) {
             if (selectedItem) {
                setSelectedItemForDeletion({
                    purchaseOrderItemRequestId: value,
                    purchaseOrderItemNumber: selectedItem.purchaseOrderItemNumber,
                    materialNumber: selectedItem.materialNumber,
                    quantity: "",
                    purchaseOrderItemSupplyId: ""
                })
            }
            setMaterialConfirmationModal(true)
        } else {
            setArrayOfPOLineItemsForDeletion(prev => prev.filter(item => item !== value))
        }
    }

    const handleMaterialConfirmation = (response: boolean) => { 
        if(response) {
            //add the selected item to the arrayOfPOLineItemsForDeletion
            setArrayOfPOLineItemsForDeletion([...arrayOfPOLineItemsForDeletion, selectedItemForDeletion.purchaseOrderItemRequestId])
            setMaterialConfirmationModal(false)
        }        
    }

    const HandleDeletePOSupplyItem = () => {
        var request:Record<string, any> = {
            what: "DeletePurchaseOrderItemSupply",
            id: selectedItemForDeletion.purchaseOrderItemSupplyId
        }
        setIsSubmitting(true)
        makeDeleteRequest(request)
            .then((response: any) => {
                toast.success(response.msg)
                setIsSubmitting(false)
                getPurchaseOrderItems(purchaseOrderId)
                setIsConfirmDeleteItemSupply(false)
            }).catch((error:any) => {
                toast.error(error.msg);
            });
    }

    const HandleDeletePOLineItems = () => {    
        const data = {            
            purchaseOrderItemRequestIds: arrayOfPOLineItemsForDeletion
        }

        var request:Record<string, any> = {
            what: "MarkAsDeleted",
            data: data
        }
        setIsSubmitting(true)
        setIsLoading(true)
        makePatchRequest(request)
            .then((response: any) => {
                toast.success(response.msg)
                setIsSubmitting(false)
                setIsLoading(false)
                getPurchaseOrderItems(purchaseOrderId)
            }).catch((error:any) => {
                toast.error(error.msg);
            });
    }

    const page = "Purchase Orders Tracking"

    return (
        <Layout title={page}>
            <div className="container">
                <div className="main">
                    <h3 className="page_title">{  }</h3>   
                    <div className="main-inner">  
                        <div className="detail-top-section">
                            <div className="d-flex-center">
                                <div style={{display: "flex", padding: "16px"}}>
                                    <div className="search-container">
                                        <span className="material-symbols-rounded">search</span>
                                        <input id="purchaseOrderNumber" placeholder="Search Purchase Orders"/>
                                    </div>
                                    <button className="custom-button orange left-item ml-2"
                                        onClick={() => {setPurchaseOrderNumber((document.getElementById("purchaseOrderNumber") as HTMLInputElement)?.value); setCurrentPage1(1)}}
                                        >Search</button> 
                                </div>                             
                            </div>
                                
                            <div className="tab">                                
                                <div className={mainTab === "items" ? "tab-item active" : "tab-item"}
                                    onClick={() => setMainTab("items")}>
                                    <span className="material-symbols-rounded">format_list_numbered</span>
                                    <p>Purchase Order Items</p>
                                </div>
                                <div className={mainTab === "summary" ? "tab-item active" : "tab-item"}
                                    onClick={() => setMainTab("summary")}>
                                    <span className="material-symbols-rounded">contract</span>
                                    <p>Purchase Order Summary</p>
                                </div> 
                                {purchaseOrderCorrespondingDocuments?.materialReadinessDocuments?.length > 0 &&
                                    <div className={mainTab === "mrd" ? "tab-item active" : "tab-item"}
                                        onClick={() => setMainTab("mrd")}>
                                        <span className="material-symbols-rounded">note_stack</span>
                                        <p>Material Readiness Documents</p>
                                    </div>
                                }  
                                {purchaseOrderCorrespondingDocuments?.proofOfCollections?.length > 0 &&
                                    <div className={mainTab === "poc" ? "tab-item active" : "tab-item"}
                                        onClick={() => setMainTab("poc")}>
                                        <span className="material-symbols-rounded">inventory</span>
                                        <p>Proof of Collections</p>
                                    </div>
                                } 
                                {purchaseOrderCorrespondingDocuments?.shippingDocuments?.length > 0 &&
                                    <div className={mainTab === "shipping" ? "tab-item active" : "tab-item"}
                                        onClick={() => setMainTab("shipping")}>
                                        <span className="material-symbols-rounded">inventory</span>
                                        <p>Shipping Documents</p>
                                    </div>
                                }                                                        
                            </div>                          
                        </div> 
                    </div> 

                    {!purchaseOrder && <div className="main-inner" style={{minHeight: "calc(100vh - 160px)"}}>
                        <p style={{fontSize: "12px", padding: "24px", color: "3e3e3e"}}>Search Purchase Order Number to Filter Items</p>
                    </div>}                    

                    {purchaseOrder && <div className="main-inner mt-1" style={{minHeight: "calc(100vh - 160px)"}}>                  
                        {mainTab === "summary" && <div className="form-view-container">
                            <div className='d-grid' style={{gap: "18px"}}>                                    
                                <div className='form-item'>
                                    <label>Purchase Order Number</label>
                                    <input type='text' disabled value={purchaseOrder?.purchaseOrderNumber} />
                                </div>   
                                <div className='form-item'>
                                    <label>Date</label>
                                    <input type='text' disabled value={formatDateTime(purchaseOrder ? purchaseOrder?.createdDate : "")} />
                                </div> 
                                <div className='form-item span-col-2'>
                                    <label>Supplier Address</label>
                                    <input type='text' disabled value={purchaseOrder?.supplierAddress} />
                                </div>  
                                <div className='form-item'>
                                    <label>Supplier</label>
                                    <input type='text' disabled value={purchaseOrder?.supplierName} />
                                </div> 
                                <div className='form-item'>
                                    <label>Supplier Phone Number</label>
                                    <input type='text' disabled value={purchaseOrder?.supplierPhoneNumber} />
                                </div>   
                                <div className='form-item'>
                                    <label>Buyer Name</label>
                                    <input type='text' disabled value={purchaseOrder?.buyerName} />
                                </div>
                                <div className='form-item span-col-2'>
                                    <label>Buyer Email</label>
                                    <input type='text' disabled value={purchaseOrder?.buyerEmail} />
                                </div>
                                <div className='form-item span-col-2'>
                                    <label>Final Shipping Address</label>
                                    <input type='text' disabled value={purchaseOrder?.finalShippingAddress}/>
                                </div>
                                <div className='form-item'>
                                    <label>Incoterms</label>
                                    <input type='text' disabled value={purchaseOrder?.incoterms}/>
                                </div>                                   
                                <div className='form-item'>
                                    <label>Total amount w/o taxes</label>
                                    <input type='text' disabled value={`${getCurrencySymbol(purchaseOrder?.purchaseOrderItems[0]?.currency)}${formatCurrency(purchaseOrder?.totalAmountTaxes)}`} />
                                </div>  
                                <div className='form-item'>
                                    <label>Total Net Amount of Order</label>
                                    <input type='text' disabled value={`${getCurrencySymbol(purchaseOrder?.purchaseOrderItems[0]?.currency)}${formatCurrency(purchaseOrder?.totalNetAmountOfOrder)}`} />
                                </div>
                                <div className='form-item'>
                                    <label>Total Amount of Order</label>
                                    <input type='text' disabled value={`${getCurrencySymbol(purchaseOrder?.purchaseOrderItems[0]?.currency)}${formatCurrency(purchaseOrder?.totalAmountOfOrder)}`} />
                                </div>
                            </div>
                        </div>} 
                        {mainTab === "items" && <div style={{minHeight: "calc(100vh - 160px)"}}>
                            <div className="inside d-flex">
                                <div className="card">
                                    <img src={number} alt="" width="40px" height="40px" />
                                    <div>
                                        <p>Purchase Order Number</p>
                                        <span>{purchaseOrder?.purchaseOrderNumber}</span>
                                    </div>
                                </div>                                
                                <div className="card">
                                    <img src={date} alt="" width="40px" height="40px" />
                                    <div>
                                        <p>Date</p>
                                        <span>{formatDateTime(purchaseOrder ? purchaseOrder?.createdDate : "")}</span>
                                    </div>
                                </div> 
                                <div className="card">
                                    <img src={status} alt="" width="36px" height="36px" />
                                    <div>
                                        <p>Total Order Amount</p>
                                        <span>{getCurrencySymbol(purchaseOrder?.purchaseOrderItems[0]?.currency)}{formatCurrency(purchaseOrder?.totalAmountOfOrder)}</span>
                                    </div>
                                </div>  
                                <div className="card">
                                    <img src={person} alt="" width="36px" height="36px" />
                                    <div>
                                        <p>Supplier</p>
                                        <span>{purchaseOrder?.supplierName??"N/A"}</span>
                                    </div>
                                </div>                               
                            </div>
                            <div className='table-container custom mt-2'>
                                <div className="filter-container">
                                    {arrayOfPOLineItemsForDeletion.length > 0 && <button className="custom-button red-outline" onClick={() => HandleDeletePOLineItems()} disabled={isSubmitting} style={{height: "34px", marginRight: "24px"}}>
                                        {isSubmitting ? "Deleting..." : "Delete Selected Items"}
                                    </button>}

                                    <div className="search-container">
                                        <span className="material-symbols-rounded" style={{fontSize: "16px"}}>search</span>
                                        <input id="searchitem" placeholder="Search" onChange={(e) => {if(e.target.value.length < 1) setSearchItem("")}}/>
                                    </div>
                                    <div className="custom-button orange" style={{height: "18px"}} onClick={() => handleItemSearch()}>Search</div>
                                    <div className={(!searchItem && !filterMaterialNumber && !itemStatus) ? "actions blue disabled" : "actions blue"} onClick={() => clearFilters()}>
                                        <span className="material-symbols-rounded">filter_alt_off</span>
                                        Clear Filters
                                    </div>                                    
                                </div>
                                <table>
                                    <thead>
                                        <tr style={{verticalAlign: "top"}}>
                                            <th style={{width: "5px"}}>#</th>
                                            <th>Item Number</th>
                                            <th>Material Number</th>
                                            <th>Material Description</th>
                                            <th>Delivery Date</th>
                                            <th>Quantity</th>
                                            <th>Unit</th>
                                            <th>Unit Price {!!poLineItems ? `(${poLineItems[0]?.currency})` : ""}</th>
                                            <th>Net Amount {!!poLineItems ? `(${poLineItems[0]?.currency})` : ""}</th>
                                            <th>Shipment Mode</th>
                                            <th>Manufacturer Part No</th>
                                            <th>Manufacturer</th>
                                            <th style={{ position: "sticky", right: '0', zIndex: '1'}}>Item Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            poLineItems?.map((data, i) => {
                                                return (
                                                    <>
                                                    <tr key={i}>
                                                        <td><input 
                                                        type="checkbox" 
                                                        value={data.id} 
                                                        checked={arrayOfPOLineItemsForDeletion.includes(data.id)} 
                                                        onChange={handleCheck}                                                         
                                                        /></td>
                                                        <td 
                                                            onClick={() => {setSelectedRow(data.id); setToggleExpand(!toggleExpand)}} style={{paddingLeft: 0, cursor: "pointer", }} 
                                                            className="fw-600 text-blue">
                                                                <div className="d-flex" style={{alignItems: "center", textWrap: "nowrap"}}>
                                                                    {(selectedRow !== data.id || !toggleExpand) && <span className="material-symbols-rounded">expand_more</span>}
                                                                    {selectedRow === data.id && toggleExpand && <span className="material-symbols-rounded">expand_less</span>}
                                                                    Item { data.purchaseOrderItemNumber }
                                                                </div>
                                                        </td>
                                                        <td>
                                                            <span onClick={() => handleCopy(data.materialNumber)} className="material-symbols-outlined mr-2" style={{fontSize: "16px", cursor: "pointer"}}>content_copy</span>{ data.materialNumber }</td>
                                                        <td>{ data.materialDescription }</td>
                                                        <td className="no-textwrap">{  formatDateTime(data.deliveryDate) }</td>
                                                        <td>{ data.quantity }</td>
                                                        <td>{ data.unit }</td>                                                    
                                                        <td>{ formatCurrency(data.unitPrice) }</td>
                                                        <td>{ formatCurrency(data.netAmount) }</td>
                                                        {/* <td>{ data.modeOfShipping??"Sea" }</td> */}
                                                        {data.modeOfTransportation==="SEA" && <td>
                                                            <span className="material-symbols-rounded" style={{marginRight:"8px", marginTop: "-10px", fontSize: "18px"}}>sailing</span>
                                                            <span>Sea</span>
                                                            </td>}
                                                        {data.modeOfTransportation==="AIR" && <td>
                                                            <span className="material-symbols-rounded" style={{marginRight:"8px", marginTop: "-10px", fontSize: "18px"}}>travel</span>
                                                            <span>Air</span>
                                                            </td>}
                                                        <td>{ data.manufacturerPartNumber }</td>
                                                        <td className="no-textwrap ">{ data.manufacturer } </td>
                                                        <td style={{ position: "sticky", right: '0'}}
                                                            className={"status "+ getPurchaseOrderItemStatus(data.status)?.color}>{getPurchaseOrderItemStatus(data.status)?.value}</td>
                                                    </tr>
                                                    {selectedRow === data.id && toggleExpand && 
                                                        <>
                                                            {data.purchaseOrderItemSupplies.length > 0 && <tr style={{backgroundColor:"white"}}>
                                                                <th style={{paddingLeft: "36px", textWrap: "nowrap"}}>Quantity</th>
                                                                <th style={{paddingLeft: "36px"}} colSpan={10}>Timeline</th>
                                                                <th style={{paddingLeft: "36px"}} colSpan={10}>Action</th>
                                                            </tr>}
                                                            {data.purchaseOrderItemSupplies.length === 0 && <p style={{marginLeft: "28px", textWrap:"nowrap"}}>No Record Found</p>}
                                                            {data.purchaseOrderItemSupplies.map((item: any, index: number) => {
                                                                return (
                                                                    <tr style={{backgroundColor:"white"}}>
                                                                        <td style={{paddingLeft: "36px"}}>{item.quantity}</td>
                                                                        <td colSpan={10} style={{paddingLeft: "0"}}>
                                                                            <Box sx={{ width: '95%' }}>
                                                                                <Stepper activeStep={getPOItemSupplyStatusIndex(item.status)} alternativeLabel>
                                                                                    {POItemSupplyStatus().map((label: any, index: number) => (
                                                                                        index > 0 ? (
                                                                                            <Step key={label.value}>
                                                                                                <StepLabel>{label.name}</StepLabel>
                                                                                            </Step>
                                                                                        ) : null
                                                                                    ))}
                                                                                </Stepper>
                                                                            </Box>
                                                                        </td>
                                                                        <td style={{paddingLeft: "36px"}}>
                                                                            <button className="custom-button red-outline" onClick={() => {
                                                                                setSelectedItemForDeletion({
                                                                                    purchaseOrderItemSupplyId: item.id,
                                                                                    materialNumber: data.materialNumber,
                                                                                    quantity: item.quantity,
                                                                                    purchaseOrderItemRequestId: "",
                                                                                    purchaseOrderItemNumber: data.purchaseOrderItemNumber
                                                                                });
                                                                                setIsConfirmDeleteItemSupply(true)
                                                                            }}>Delete</button>
                                                                        </td>
                                                                    </tr>
                                                                )
                                                            })

                                                            }                                                            
                                                        </>
                                                    }
                                                    </>
                                                )
                                            })
                                        }
                                    </tbody>
                                </table>
                            </div>
                            {/* {isLoading ? <div className="loader">
                                        <img src={loading} alt="loading" />
                                        <p>Loading data...</p>
                                    </div> : null} */}

                            <div className="pagination-container">
                                <Pagination
                                currentPage={currentPage1}
                                itemsPerPage={itemsPerPage1}
                                totalPages={totalPages1}
                                handlePrevious={handlePrevious}
                                handleNext={handleNext}
                                setCurrentPage={setCurrentPage1}
                                getPageNumbers={getPageNumbers}
                                setItemsPerPage={setItemsPerPage1} 
                                startIndex={startIndex}
                                />
                            </div>
                        </div>}
                        {mainTab === "mrd" && <div style={{minHeight: "calc(100vh - 160px)"}}>
                            <div className='table-container custom'>
                                <table>
                                    <thead>
                                        <tr className="no-textwrap">
                                            <th style={{padding: "16px"}}>SN</th>
                                            <th>MRD Number</th>
                                            <th>Issuance Date</th>
                                            <th>Pickup Country</th>
                                            <th>Delivery Destination</th>
                                            {/* <th>Currency</th> */}
                                            <th>Status</th>
                                            <th style={{width: "120px"}}>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {
                                        purchaseOrderCorrespondingDocuments?.materialReadinessDocuments?.map((data: any, index: number) => {
                                                    return (
                                                        <tr key={index}>
                                                            <td>{ index + 1 }</td>
                                                            <td className="no-textwrap">{ data.mrdNumber }</td>
                                                            <td>{ formatDateTime(data.createdDate) }</td>
                                                            <td>{ data.countryOfSupply }</td>
                                                            <td>{ data.destination }</td>
                                                            {/* <td>{ data.currency }</td> */}
                                                            <td className="uppercase" style={{color: getCAndPMAterialReadinessDocumentStatus(data?.materialReadinessDocumentStatus).color}}
                                                            >{ getCAndPMAterialReadinessDocumentStatus(data?.materialReadinessDocumentStatus).status }</td>
                                                            <td className="actions">
                                                                <button onClick={() => navigate("/candp/materialreadinessdocument/"+data.id, {state: {status: status, origin: "/candp/purchaseorders/"+purchaseOrderNumber, pageNumber: 1}})} className="actions">
                                                                    <span className="material-symbols-rounded">pageview</span>
                                                                    <span>View Details</span>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                    }
                                    </tbody>
                                </table>
                            </div>
                        </div>}
                        {mainTab === "poc" && <div style={{minHeight: "calc(100vh - 160px)"}}>
                            <div className='table-container custom'>
                                <table>
                                    <thead>
                                        <tr className="no-textwrap">
                                            <th style={{padding: "16px"}}>SN</th>
                                            <th>POC Number</th>
                                            <th>Date Created</th>
                                            <th>Pick Up Date</th>
                                            <th>MRD Number</th>
                                            <th>Freight Forwarder</th>
                                            {/* <th>Supplier Acknowledged</th> */}
                                            <th style={{width: "110px"}}>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            purchaseOrderCorrespondingDocuments?.proofOfCollections
                                            ?.filter((data: any) => data !== null)
                                            .map((data: any, index: number) => {
                                                return (
                                                    <tr key={index}>
                                                        <td>{ index + 1 }</td>
                                                        <td>{ data?.pocNumber }</td>
                                                        <td>{ formatDateTime(data?.createdDate) }</td>
                                                        <td>{ formatDateTime(data?.pickUpDate).substring(0, 10) }</td>
                                                        <td>{ data?.materialReadinessDocuments ? data?.materialReadinessDocuments[0]?.mrdNumber : null  }</td>
                                                        <td>{ data?.freightForwarderCompanyName  }</td><td>
                                                            <button onClick={() => navigate("/candp/proofofcollection/"+data.id, {state: {status: status, origin: "/candp/purchaseorders/"+purchaseOrderNumber}})} className="actions">
                                                                <span className="material-symbols-rounded">pageview</span>
                                                                <span>View Details</span>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>}
                        {mainTab === "shipping" && <div style={{minHeight: "calc(100vh - 160px)"}}>
                            <div className='table-container custom'>
                                <table>
                                    <thead>
                                        <tr className="no-textwrap">
                                            <th style={{padding: "16px"}}>SN</th>
                                            <th>BL/AWB Number</th>
                                            <th>Shipment Number</th>
                                            {/* <th>Shipping Mode</th>
                                            <th>Currency</th>
                                            <th>Destination</th> */}
                                            <th title='Estimated Time of Departure'>ETD</th>
                                            <th title='Estimated Time of Arrival'>ETA</th>
                                            <th title='Actual Time of Arrival'>ATA</th>
                                            <th>Shipment Confirmed</th>
                                            {/* <th style={{width: "116px"}}>Action</th> */}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            purchaseOrderCorrespondingDocuments?.shippingDocuments
                                            ?.map((data: any, index: number) => {
                                                return (
                                                    <tr key={index}>
                                                    <td>{ index + 1 }</td>
                                                    <td>{ data.referenceNumber ?? "N/A" }</td>
                                                    <td>{ data.shippingNumber }</td>
                                                    {/* <td>{ data.consolidatedCommercialInvoice?.modeOfShipping }</td>
                                                    <td>{ data?.consolidatedCommercialInvoice?.purchaseOrderItemSupplies[0]?.currency }</td>
                                                    <td>{ data.consolidatedCommercialInvoice?.destination }</td> */}
                                                    <td>
                                                        <span>{formatDateTime(data.estimatedTimeOfDeparture).substring(0, 10)}</span>
                                                    </td>
                                                    <td>
                                                        <span>{formatDateTime(data.estimatedTimeOfArrival).substring(0, 10)}</span>      
                                                    </td>  
                                                    <td>
                                                        <span>{formatDateTime(data.actualTimeOfArrival).substring(0, 10)}</span>
                                                    </td>
                                                    <td>
                                                        {(data?.vesselName && data?.containerDescription) && 
                                                        <div className='d-flex-2'>
                                                            <span className="material-symbols-rounded text-green fw-500" style={{fontSize: "16px"}}>check</span>
                                                            <span>Shipped</span>
                                                        </div>
                                                        }
                                                        {!(data?.vesselName && data?.containerDescription) && 
                                                        <div className='d-flex-2'>
                                                            <span className="material-symbols-rounded text-yellow fw-600" style={{fontSize: "16px"}} >hourglass_top</span>
                                                            <span>Awaiting Shipment</span>
                                                        </div>
                                                        }
                                                    </td>
                                                </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </table>
                                {isLoading ? <div className="loader">
                                            <img src={loading} alt="loading" />
                                            <p>Loading data...</p>
                                        </div> : null}
                            </div>
                        </div>}
                    </div>}                                 
                </div>
                <Modal isOpen={materialConfirmationModal} style={customStyles} className="modal modal-4" ariaHideApp={false}>
                    <div className="modal-header">
                        <h3>Confirm Item Deletion</h3>
                        <span className="material-symbols-rounded close"
                            onClick={() => setMaterialConfirmationModal(false)}>close</span>
                    </div>
                    <div className="modal-body">
                        <p style={{lineHeight: "1.5em"}}>You are confirming that <strong>Item {selectedItemForDeletion.purchaseOrderItemNumber} with Material Number {selectedItemForDeletion.materialNumber}</strong> is to be deleted.</p>
                    </div>
                    <div className="modal-footer bt-1">
                        <button type="button" className="custom-button grey-outline"
                            onClick={() => setMaterialConfirmationModal(false)}>Cancel</button>
                        <button type="submit" className="custom-button orange"
                            onClick={() => handleMaterialConfirmation(true)}>Yes</button>
                    </div>
                </Modal>

                <Modal isOpen={isConfirmDeleteItemSupply} style={customStyles} className="modal modal-4" ariaHideApp={false}>
                    <div className="modal-header">
                        <h3>Confirm PO Item Supply Deletion</h3>
                        <span className="material-symbols-rounded close"
                            onClick={() => setIsConfirmDeleteItemSupply(false)}>close</span>
                    </div>
                    <div className="modal-body">
                        <p style={{lineHeight: "1.5em"}}>You are confirming that <strong>supplied Item {selectedItemForDeletion.purchaseOrderItemNumber} with quantity, {selectedItemForDeletion.quantity}</strong> is to be deleted.</p>
                    </div>
                    <div className="modal-footer bt-1">
                        <button type="button" className="custom-button grey-outline"
                            onClick={() => setIsConfirmDeleteItemSupply(false)}>Cancel</button>
                        <button type="submit" className="custom-button orange"
                            disabled={isSubmitting}
                            onClick={() => HandleDeletePOSupplyItem()}>{isSubmitting ? "Deleting..." : "Yes"}</button>
                    </div>
                </Modal>
                
                <Modal isOpen={isLoading} style={customStyles} className="modal modal-sm" ariaHideApp={false}>
                    <div className="loader">
                        <img src={loading} alt="loading" />
                        <p>Loading data...</p>
                    </div>
                </Modal>
                <ToastContainer />
            </div>
        </Layout>
    )
}

export default PurchaseOrder